import {ActivityAwardItem} from '../../type';

export const calculateCurrentPurchaseBonus = (
  progressValue: number,
  awardList: ActivityAwardItem[],
) => {
  const currentProgress = Math.max(Number(progressValue) || 0, 0);
  const currentAward = awardList.find(item => {
    const minAmount = Number(item.minAmount) || 0;
    const maxAmount = Number(item.maxAmount);
    return (
      currentProgress >= minAmount &&
      (!Number.isFinite(maxAmount) || currentProgress <= maxAmount)
    );
  });

  if (!currentAward) {
    return 0;
  }

  const awardValue = Number(currentAward.value) || 0;
  if (currentAward.valueType === 'PERCENT_VALUE') {
    return (currentProgress * awardValue) / 100;
  }
  return awardValue;
};
